import React, { forwardRef } from 'react';
import { StyledHeadline } from './index.styles.js';
import {} from '@oneaudi/unified-web-alpha-common';
import { pickDataProps } from '../../utils/pick-data-props.js';
import { pickA11yProps } from '../../utils/pick-a11y-props.js';
export const Headline = forwardRef(({ tag, children, variant, className, margin, id, textAlign, ...rest }, ref) => {
    return (React.createElement(StyledHeadline, { as: tag, id: id, className: className, variant: variant, ref: ref, margin: margin, "$textAlign": textAlign, ...pickDataProps(rest), ...pickA11yProps(rest) }, children));
});
Headline.displayName = 'Headline';
//# sourceMappingURL=index.js.map